/* Onglets de rayon de l'accueil mobile (prototype validé « étape 2 ») — MOBILE uniquement, page d'accueil.
   - Les liens du header vers une collection (Tutti i Prodotti, Donna, Uomo…, menu réel) deviennent des onglets : un toucher
     ouvre la page du rayon SANS recharger la page (/collections/<rayon>?view=mshein-dept, snippets/mshein-dept.liquid),
     placée à la place de la bannière, des tuiles, des cartes 2×2 et du fil (la bande avantages et le coupon restent).
   - Comme SHEIN : glisser le doigt à gauche / à droite passe au rayon voisin (la page suit le doigt puis glisse) ;
     la page arrive tout de suite (forme grise en attendant), les rayons voisins sont préparés à l'avance ; en-tête et
     bannière tout de suite, puis les autres blocs l'un après l'autre, vite (avantages, catégories, coupon, cartes, produits).
   - Chaque onglet affiche la vraie adresse de son rayon (/collections/abbigliamento-donna-tutti…) : lien partagé ou page
     rechargée = la vraie page collection, au même design ; Retour / Avanti du navigateur reviennent à l'onglet précédent,
     à la même position. Retour à l'accueil : logo ou « Home » de la barre du bas.
   - Bloc de recherche du rayon : puces des sous-catégories, Filtri (vrais filtres Shopify), tri, 2 colonnes / 1 colonna,
     filtres rapides ; produits en 2 colonnes décalées (window.msheinMasonry, assets/mobile-home-shein.js).
   Les autres liens du header (Contatti, Traccia ordine…) restent des liens normaux.
   Pages collection (templates/collection.json, [data-mshein-coll]) : même principe, la page de base est la collection
   elle-même (au design des rayons) ; ses blocs sont remplacés par ceux de l'onglet touché, Retour la remet. */
(function () {
  'use strict';

  /* ---------- Bloc de recherche et produits (rayons, pages collection, recherche) ---------- */
  // query : tri / filtres déjà dans l'adresse (page collection ouverte avec ?sort_by=…, ?filter…, recherche ?q=…).
  // view : modèle sans layout qui renvoie le bloc (mshein-dept pour les collections, mshein-search pour la recherche).
  var createProducts = function (slot, basePath, query, view) {
    view = view || 'mshein-dept';
    var results = slot.querySelector('[data-dept-results]');
    var params = new URLSearchParams(query || '');
    params.delete('page');
    params.delete('view');
    var oneColumn = false;
    var masonry = null;
    var token = 0;
    var sheetHome = null;

    var updateCount = function () {
      var count = results && results.querySelector('[data-dept-count]');
      if (!count || !masonry) return;
      count.innerHTML = String(count.getAttribute('data-template'))
        .replace('{count}', masonry.cardCount())
        .replace('{total}', count.getAttribute('data-total'));
    };
    // Rayons et pages collection au tri par défaut, sans filtre : produits et pages dans un ordre au hasard, pour que
    // le client voie d'autres produits à chaque visite (assets/mobile-home-shein.js). Tri ou filtre choisis, recherche,
    // « In offerta » : ordre de Shopify gardé.
    var randomInfo = function () {
      if (view !== 'mshein-dept') return null;
      var chosen = false;
      params.forEach(function (value, key) {
        if (key === 'sort_by' || key === 'q' || key.indexOf('filter.') === 0) chosen = true;
      });
      var count = results.querySelector('[data-dept-count]');
      var total = count ? Number(count.getAttribute('data-total')) : 0;
      return chosen || !(total > 20) ? null : { total: total, perPage: 20, shown: 1 };
    };
    var bind = function () {
      if (masonry) masonry.destroy();
      var grid = results.querySelector('[data-mshein-grid]');
      var sentinel = results.querySelector('[data-mshein-sentinel]');
      var random = randomInfo();
      masonry = window.msheinMasonry.create({
        grid: grid,
        sentinel: sentinel,
        loader: results.querySelector('[data-mshein-loader]'),
        onCards: updateCount,
        random: Boolean(random),
        // Ordinateur (recherche) : grille de la page (assets/desktop-search.css) au lieu des 2 colonnes décalées.
        flat: !window.matchMedia('(max-width: 760px)').matches
      });
      masonry.setSource(sentinel && sentinel.getAttribute('data-next'), true, random);
      if (oneColumn) masonry.setOneColumn(true);
      results.querySelectorAll('[data-dept-view]').forEach(function (button) {
        button.classList.toggle('is-on', button.getAttribute('data-dept-view') === (oneColumn ? '1' : '2'));
      });
      updateCount();
    };
    var scrollToBlock = function () {
      var block = slot.querySelector('[data-dept-block]');
      var rootStyle = getComputedStyle(document.documentElement);
      // Ordinateur : sous l'en-tête collant (--dh-h, assets/desktop-header.js).
      var top = block.getBoundingClientRect().top + window.scrollY - (parseFloat(rootStyle.getPropertyValue('--mshein-tabs-top')) || parseFloat(rootStyle.getPropertyValue('--mshein-header-h')) || parseFloat(rootStyle.getPropertyValue('--dh-h')) || 0);
      if (window.scrollY > top) window.scrollTo({ top: top });
    };
    // Bloc des résultats seul (collection.mshein-dept-results : sans bannière ni cartes du rayon, plus léger). Une même
    // demande sert au nombre de « Mostra N prodotti » et aux produits : « Mostra » affiche tout de suite ce qui est
    // déjà arrivé (ou attend la même demande, sans en refaire une).
    var resultsView = view === 'mshein-dept' ? 'mshein-dept-results' : view;
    var resultsCache = {};
    var resultsOrder = [];
    var fetchResults = function (query) {
      var key = basePath + '?' + query;
      if (!resultsCache[key]) {
        resultsCache[key] = fetch(basePath + '?view=' + resultsView + (query ? '&' + query : ''), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Department results request failed: ' + response.status);
            return response.text();
          });
        resultsCache[key].catch(function () { delete resultsCache[key]; });
        resultsOrder.push(key);
        if (resultsOrder.length > 8) delete resultsCache[resultsOrder.shift()];
      }
      return resultsCache[key];
    };
    // Barre de chargement sous l'en-tête (la même que pour changer de page) pendant que les produits arrivent.
    var progress = function (on) {
      if (on && !document.querySelector('.mobile-navigation-progress')) {
        var bar = document.createElement('div');
        bar.className = 'mobile-navigation-progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.appendChild(document.createElement('span'));
        document.body.appendChild(bar);
      }
      document.documentElement.classList.toggle('mobile-page-loading', on);
    };
    // Tri, filtres ou puce : seulement la partie résultats est redemandée (mêmes vrais filtres que la page collection).
    var reload = function () {
      var myToken = ++token;
      var query = params.toString();
      results.classList.add('is-loading');
      progress(true);
      scrollToBlock();
      fetchResults(query)
        .then(function (html) {
          if (myToken !== token) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dept-results]');
          if (!fresh) throw new Error('Department results markup missing');
          var imported = document.importNode(fresh, true);
          results.replaceWith(imported);
          results = imported;
          bind();
          // Fenêtre Filtri restée ouverte (choix retiré) : remplacée par la nouvelle, aux nombres à jour.
          if (movedPanel) adoptSheet();
          scrollToBlock();
          progress(false);
          // Adresse de la page = filtres et tri en cours (page rechargée ou partagée : mêmes produits).
          if (window.location.pathname === basePath) {
            History.prototype.replaceState.call(window.history, window.history.state, '', basePath + (query ? '?' + query : '') + window.location.hash);
          }
        })
        .catch(function (error) {
          console.error('Unable to update the department products.', error);
          if (myToken === token) {
            results.classList.remove('is-loading');
            progress(false);
          }
        });
    };

    // Fenêtre Filtri de CE bloc (la page collection et un onglet ouvert ont chacun la leur).
    var movedPanel = null;
    var sheet = function () { return movedPanel || results.querySelector('[data-dept-sheet]'); };

    // Fenêtre Filtri (prototype « Filtri v2 ») : tous les choix sont de vraies cases / champs du formulaire.
    var money = function (box, value) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: box.getAttribute('data-currency') || 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(Number(value));
      } catch (error) {
        return value;
      }
    };
    var priceLabel = function (box, min, max) {
      if (min !== '' && max !== '') return money(box, min) + ' – ' + money(box, max);
      if (min !== '') return String(box.getAttribute('data-over')).replace('{amount}', money(box, min));
      return String(box.getAttribute('data-up-to')).replace('{amount}', money(box, max));
    };

    // Choix en pastilles sous le titre (✕ sur chacune), nombre à côté de « Filtri », « Azzera » actif seulement avec
    // un choix, et résumé dans le titre de chaque section (« Tutti », « Abiti +2 », « CHF 10 – CHF 50 »).
    var renderPicked = function (panel) {
      var box = panel.querySelector('[data-dept-picked]');
      if (!box) return;
      var all = panel.querySelector('[data-dept-sheet-body]').getAttribute('data-all');
      var picks = [];
      panel.querySelectorAll('[data-dept-section]').forEach(function (section) {
        var labels = [];
        // Préfixe des pastilles (« Taglia M », « N° 38 »), sauf si la valeur le dit déjà (« Taglia unica »).
        var withPrefix = function (prefix, label) {
          if (!prefix || label.toLowerCase().indexOf(prefix.toLowerCase()) === 0) return label;
          return prefix + ' ' + label;
        };
        var chipPrefix = section.getAttribute('data-chip-prefix') || '';
        var summaryPrefix = section.getAttribute('data-summary-prefix') || '';
        // Valeurs réunies sous une couleur (black, Black…) : une seule pastille, celle de la couleur.
        // .checked plutôt que :checked : une couleur choisie en partie (indeterminate) ne répond plus à :checked.
        Array.prototype.filter.call(section.querySelectorAll('input[type="checkbox"]:not([data-family-member])'), function (input) {
          return input.checked;
        }).forEach(function (input) {
          var label = input.getAttribute('data-label') || input.value;
          // Couleur choisie en partie (quelques tonalités) : « Rosso · 2 ».
          if (input.indeterminate) {
            var key = input.getAttribute('data-dept-family');
            label += ' · ' + shadeVisible(section, key).filter(function (member) { return member.checked; }).length;
          }
          labels.push(withPrefix(summaryPrefix, label));
          picks.push({ label: withPrefix(chipPrefix, label), input: input, color: input.getAttribute('data-color') });
        });
        var min = section.querySelector('[data-dept-price="min"]');
        var max = section.querySelector('[data-dept-price="max"]');
        if (min && max && (min.value.trim() !== '' || max.value.trim() !== '')) {
          var label = priceLabel(box, min.value.trim(), max.value.trim());
          labels.push(label);
          picks.push({ label: label, price: [min, max] });
        }
        var summary = section.querySelector('[data-dept-summary]');
        if (summary) {
          summary.textContent = labels.length ? labels[0] + (labels.length > 1 ? ' +' + (labels.length - 1) : '') : all;
          summary.classList.toggle('is-on', labels.length > 0);
        }
      });
      box.replaceChildren.apply(box, picks.map(function (pick, index) {
        var chip = document.createElement('span');
        chip.className = 'mshein-fchip';
        if (pick.color) {
          var dot = document.createElement('i');
          dot.className = 'mshein-fsw__dot is-' + pick.color;
          chip.appendChild(dot);
        }
        chip.appendChild(document.createTextNode(pick.label));
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('data-dept-unpick', index);
        remove.setAttribute('aria-label', box.getAttribute('data-remove') + ' : ' + pick.label);
        remove.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        chip.appendChild(remove);
        return chip;
      }));
      box.msheinPicks = picks;
      box.hidden = picks.length === 0;
      panel.querySelector('[data-dept-picked-clear]').disabled = picks.length === 0;
      var total = panel.querySelector('[data-dept-picked-count]');
      if (total) {
        total.hidden = picks.length === 0;
        total.textContent = picks.length;
      }
    };

    // Prezzo : curseur double à échelle non linéaire (sinon tout le catalogue tiendrait dans le début de la barre),
    // relié aux champs min / max (les vrais paramètres envoyés) et aux prix rapides.
    var CURVE = 8;
    var priceOf = function (max, t) {
      return t >= 1 ? max : (Math.exp(CURVE * t) - 1) / (Math.exp(CURVE) - 1) * max;
    };
    var placeOf = function (max, price) {
      return Math.min(1, Math.log(1 + price / max * (Math.exp(CURVE) - 1)) / CURVE);
    };
    var roundPrice = function (price) {
      return price < 20 ? Math.round(price) : price < 200 ? Math.round(price / 5) * 5 : price < 1000 ? Math.round(price / 10) * 10 : Math.round(price / 100) * 100;
    };
    var samePrice = function (a, b) {
      return (a === '' && b === '') || (a !== '' && b !== '' && Number(a) === Number(b));
    };
    var syncPrice = function (section, fromSlider) {
      var range = section.querySelector('[data-dept-range]');
      if (!range) return;
      var max = Number(range.getAttribute('data-max')) || 1;
      var minInput = section.querySelector('[data-dept-price="min"]');
      var maxInput = section.querySelector('[data-dept-price="max"]');
      var low = minInput.value.trim() === '' ? 0 : placeOf(max, Number(minInput.value));
      var high = maxInput.value.trim() === '' ? 1 : placeOf(max, Number(maxInput.value));
      if (!fromSlider) {
        range.querySelector('[data-dept-range-input="min"]').value = Math.round(low * 1000);
        range.querySelector('[data-dept-range-input="max"]').value = Math.round(high * 1000);
      }
      var fill = range.querySelector('[data-dept-range-fill]');
      fill.style.left = (low * 100) + '%';
      fill.style.right = ((1 - high) * 100) + '%';
      section.querySelectorAll('[data-dept-pq-min]').forEach(function (button) {
        var on = samePrice(minInput.value.trim(), button.getAttribute('data-dept-pq-min')) && samePrice(maxInput.value.trim(), button.getAttribute('data-dept-pq-max'));
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    var slidePrice = function (input) {
      var section = input.closest('[data-dept-section]');
      var range = input.closest('[data-dept-range]');
      var max = Number(range.getAttribute('data-max')) || 1;
      var low = range.querySelector('[data-dept-range-input="min"]');
      var high = range.querySelector('[data-dept-range-input="max"]');
      var a = Number(low.value);
      var b = Number(high.value);
      if (a > b - 20) {
        if (input === low) a = b - 20;
        else b = a + 20;
        low.value = a;
        high.value = b;
      }
      section.querySelector('[data-dept-price="min"]').value = a <= 0 ? '' : roundPrice(priceOf(max, a / 1000));
      section.querySelector('[data-dept-price="max"]').value = b >= 1000 ? '' : roundPrice(priceOf(max, b / 1000));
      syncPrice(section, true);
    };

    // Listes longues (Categoria…) : recherche dans la section (texte trouvé surligné), « Mostra altre (N) ».
    var searchList = function (input) {
      var section = input.closest('[data-dept-section]');
      var words = input.value.trim();
      var lower = words.toLowerCase();
      var shown = 0;
      section.querySelectorAll('.mshein-fck').forEach(function (row) {
        var label = row.querySelector('input').getAttribute('data-label') || '';
        var at = lower ? label.toLowerCase().indexOf(lower) : -1;
        var hit = !lower || at >= 0;
        row.hidden = !hit;
        if (hit) shown += 1;
        var name = row.querySelector('[data-dept-name]');
        name.textContent = '';
        if (at >= 0) {
          var mark = document.createElement('mark');
          mark.textContent = label.slice(at, at + words.length);
          name.append(label.slice(0, at), mark, label.slice(at + words.length));
        } else {
          name.textContent = label;
        }
      });
      section.classList.toggle('is-searching', lower !== '');
      var none = section.querySelector('[data-dept-none]');
      if (none) {
        none.hidden = shown > 0;
        none.textContent = String(none.getAttribute('data-template')).replace('{amount}', words);
      }
    };

    // Tailles / pointures : ordre numérique quand toutes les valeurs sont des nombres (Shopify donne 4…47 puis 10,5…),
    // 12 premières visibles puis « Mostra altre » (une valeur choisie reste toujours visible).
    var sortGrids = function (panel) {
      panel.querySelectorAll('[data-dept-grid]').forEach(function (grid) {
        if (grid.getAttribute('data-sorted') === 'true') return;
        grid.setAttribute('data-sorted', 'true');
        var chips = Array.prototype.slice.call(grid.children);
        var numberOf = function (chip) {
          return Number(String(chip.querySelector('input').getAttribute('data-label')).trim().replace(',', '.'));
        };
        if (chips.every(function (chip) { return !isNaN(numberOf(chip)); })) {
          chips.sort(function (a, b) { return numberOf(a) - numberOf(b); });
          chips.forEach(function (chip) { grid.appendChild(chip); });
        }
        chips.forEach(function (chip, index) {
          chip.classList.toggle('is-more', index >= 12 && !chip.querySelector('input').checked);
        });
      });
    };

    // Sections : ouvertes / fermées d'un toucher sur leur titre.
    var setSection = function (section, open) {
      section.classList.toggle('is-open', open);
      section.querySelector('[data-dept-toggle]').setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    // Raccourci « Categoria », « Color »… sous la barre : seule sa section ouverte, amenée en haut et signalée.
    var openSection = function (panel, index) {
      var target = panel.querySelector('.mshein-fsec[data-dept-section="' + index + '"]');
      if (!target) return;
      panel.querySelectorAll('.mshein-fsec').forEach(function (section) { setSection(section, section === target); });
      var body = panel.querySelector('[data-dept-sheet-body]');
      window.setTimeout(function () {
        body.scrollTo({ top: body.scrollTop + target.getBoundingClientRect().top - body.getBoundingClientRect().top - 4, behavior: 'smooth' });
        target.classList.remove('is-flash');
        void target.offsetWidth;
        target.classList.add('is-flash');
      }, 300);
    };
    // Couleur cochée (Nero…) : toutes ses vraies valeurs de la boutique (black, Black, Black thick…) suivent.
    var setFamily = function (input, checked) {
      input.checked = checked;
      input.indeterminate = false;
      input.closest('[data-dept-section]').querySelectorAll('[data-family-member="' + input.getAttribute('data-dept-family') + '"]').forEach(function (member) {
        member.checked = checked;
      });
    };
    // Tonalità choisies une à une : la couleur est cochée si au moins une l'est, « en partie » (anneau en
    // pointillé) si elles ne le sont pas toutes.
    // Petit rond de couleur de chaque tonalité, d'après son vrai nom : « Dark grey » → gris foncé, « Brown grey » →
    // mélange brun / gris, « Light blue » → bleu clair ; nom sans couleur connue : la couleur du rond de la famille.
    // Couleurs de base = celles des ronds (les couleurs nommées du navigateur trompent : « darkgrey » y est plus clair
    // que « grey », « brown » y est rouge).
    var SHADE_WORDS = { black: '#1a1a1a', nero: '#1a1a1a', white: '#fafafa', bianco: '#fafafa', grey: '#9a9da6', gray: '#9a9da6', grigio: '#9a9da6', red: '#c8102e', rosso: '#c8102e', pink: '#f2a7c3', rosa: '#f2a7c3', orange: '#f28b2c', arancione: '#f28b2c', yellow: '#f2c230', giallo: '#f2c230', green: '#3e6b48', verde: '#3e6b48', blue: '#2c4a8c', blu: '#2c4a8c', purple: '#8e6fa8', viola: '#8e6fa8', brown: '#7a4e2d', marrone: '#7a4e2d', beige: '#d9c3a5', azzurro: '#8ec5e8', oro: '#d4af37', gold: '#d4af37', argento: '#c0c4cc', silver: '#c0c4cc', khaki: '#b7a77a', kaki: '#b7a77a', camel: '#c19a6b', apricot: '#fbceb1', wine: '#722f37', burgundy: '#800020', bordeaux: '#800020', navy: '#1b2a4e', rose: '#e8607e', rosy: '#e8607e', coffee: '#6f4e37', champagne: '#f7e7ce', mint: '#98ff98', army: '#4b5320', olive: '#5b6236', nude: '#e3bc9a', cream: '#fffdd0', ivory: '#fffff0' };
    var shadeColor = function (name) {
      var valid = function (color) { return color && window.CSS && CSS.supports('color', color) ? color : null; };
      var words = name.toLowerCase().replace(/[^a-zà-ù\s]/g, ' ').split(/\s+/).filter(Boolean);
      var tinted = words.some(function (word) { return /^(light|pale|baby|soft|pastel|chiaro|dark|deep|scuro)$/.test(word); });
      var whole = !tinted && words.length > 1 && valid(words.join(''));
      if (whole) return whole;
      var colors = words.map(function (word) { return valid(SHADE_WORDS[word]) || valid(word); }).filter(Boolean);
      if (!colors.length) return null;
      var color = colors.length > 1 ? 'color-mix(in srgb, ' + colors[colors.length - 2] + ', ' + colors[colors.length - 1] + ')' : colors[0];
      if (/\b(light|pale|baby|soft|pastel|chiaro)\b/.test(name.toLowerCase())) return 'color-mix(in srgb, ' + color + ', #fff 45%)';
      if (/\b(dark|deep|scuro)\b/.test(name.toLowerCase())) return 'color-mix(in srgb, ' + color + ', #000 35%)';
      return color;
    };

    // Couleur → rouge / vert / bleu (via un petit canvas, qui comprend aussi color-mix), pour comparer deux tonalités.
    var rgbCanvas = null;
    var rgbOf = function (color) {
      try {
        rgbCanvas = rgbCanvas || document.createElement('canvas').getContext('2d', { willReadFrequently: true });
        rgbCanvas.clearRect(0, 0, 1, 1);
        rgbCanvas.fillStyle = '#000';
        rgbCanvas.fillStyle = color;
        rgbCanvas.fillRect(0, 0, 1, 1);
        var data = rgbCanvas.getImageData(0, 0, 1, 1).data;
        return [data[0], data[1], data[2]];
      } catch (error) {
        return null;
      }
    };
    // Écart sous lequel l'œil ne voit pas de vraie différence (Ivory / White, Rose red / Rosy red).
    var SAME_SHADE = 40;
    var sameShade = function (a, b) {
      return a && b && Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2)) < SAME_SHADE;
    };

    // Tonalità de même couleur (Red, red, RED ; Rose red, Rosy red ; Ivory, White) : une seule pastille qui les coche toutes.
    var mergeShades = function (panel) {
      panel.querySelectorAll('[data-dept-shades]').forEach(function (shades) {
        if (shades.getAttribute('data-merged') === 'true') return;
        shades.setAttribute('data-merged', 'true');
        var firsts = {};
        var seen = [];
        shades.querySelectorAll('.mshein-fshade').forEach(function (pill) {
          var input = pill.querySelector('input');
          var name = String(input.getAttribute('data-label')).trim().replace(/\s+/g, ' ');
          // Même nom, ou couleur que l'œil ne distingue pas : une seule pastille, nom de la première.
          var color = shadeColor(name);
          var rgb = color ? rgbOf(color) : null;
          var key = 'name:' + name.toLowerCase();
          var first = firsts[key];
          if (!first && rgb) {
            var match = seen.filter(function (item) { return sameShade(item.rgb, rgb); })[0];
            if (match) first = match.input;
          }
          if (!first) {
            firsts[key] = input;
            if (rgb) seen.push({ rgb: rgb, input: input });
            input.msheinTwins = [];
            var text = pill.querySelector('span');
            text.textContent = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
            var dot = document.createElement('i');
            dot.className = 'mshein-fshade__dot mshein-fsw__dot is-' + shades.getAttribute('data-dept-shades');
            dot.setAttribute('aria-hidden', 'true');
            if (color) dot.style.background = color;
            text.prepend(dot);
            return;
          }
          first.msheinTwins.push(input);
          if (input.checked) first.checked = true;
          pill.hidden = true;
        });
        // Une seule tonalité une fois réunies : pas de flèche sur le rond.
        if (Object.keys(firsts).length < 2) {
          var button = shades.closest('[data-dept-section]').querySelector('[data-dept-shades-open="' + shades.getAttribute('data-dept-shades') + '"]');
          if (button) button.hidden = true;
        }
      });
    };
    var shadeVisible = function (section, key) {
      return Array.prototype.filter.call(section.querySelectorAll('[data-family-member="' + key + '"]'), function (input) {
        return !input.closest('.mshein-fshade[hidden]');
      });
    };
    var syncFamily = function (section, key) {
      var family = section.querySelector('[data-dept-family="' + key + '"]');
      if (!family) return;
      var members = shadeVisible(section, key);
      var checked = members.filter(function (input) { return input.checked; }).length;
      family.checked = checked > 0;
      family.indeterminate = checked > 0 && checked < members.length;
    };
    var syncFamilies = function (panel) {
      panel.querySelectorAll('[data-dept-family]').forEach(function (family) {
        syncFamily(family.closest('[data-dept-section]'), family.getAttribute('data-dept-family'));
      });
    };
    // Flèche sur un rond : panneau « Tonalità · Rosso » (un seul ouvert à la fois).
    var toggleShades = function (button) {
      var section = button.closest('[data-dept-section]');
      var key = button.getAttribute('data-dept-shades-open');
      var opening = button.getAttribute('aria-expanded') !== 'true';
      section.querySelectorAll('[data-dept-shades-open]').forEach(function (other) { other.setAttribute('aria-expanded', 'false'); });
      section.querySelectorAll('[data-dept-shades]').forEach(function (shades) { shades.hidden = true; });
      if (!opening) return;
      button.setAttribute('aria-expanded', 'true');
      var shades = section.querySelector('[data-dept-shades="' + key + '"]');
      shades.hidden = false;
      shades.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };
    // « Mostra N risultati » : nombre de produits avec les choix en cours, demandé à Shopify (même page que le
    // résultat, gardée pour l'afficher tout de suite à « Mostra »).
    var countToken = 0;
    var countTimer = null;
    var formQuery = function (form) {
      var query = withoutFilters();
      new FormData(form).forEach(function (value, name) {
        if (String(value).trim() !== '') query.append(name, value);
      });
      return query.toString();
    };
    // « Mostra 4.112 prodotti » / « Mostra 1 prodotto » / « Nessun prodotto » (bouton éteint) ; petit battement
    // quand le nombre change.
    var setGo = function (go, total, quiet) {
      var text = total === 0 ? go.getAttribute('data-zero')
        : total === 1 ? go.getAttribute('data-one')
        : String(go.getAttribute('data-template')).replace('{count}', total.toLocaleString(document.documentElement.lang || undefined));
      go.disabled = total === 0;
      if (go.textContent.trim() === text) return;
      go.textContent = text;
      if (quiet) return;
      go.classList.remove('is-tick');
      void go.offsetWidth;
      go.classList.add('is-tick');
    };
    var refreshCount = function (panel) {
      var go = panel.querySelector('[data-dept-go]');
      if (!go) return;
      var myToken = ++countToken;
      window.clearTimeout(countTimer);
      go.classList.add('is-counting');
      // Demande lancée presque tout de suite (le temps de cocher une 2e case) : les produits arrivent avec le nombre.
      countTimer = window.setTimeout(function () {
        fetchResults(formQuery(panel.querySelector('[data-dept-form]')))
          .then(function (html) {
            if (myToken !== countToken) return;
            var count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dept-count]');
            go.classList.remove('is-counting');
            if (count) setGo(go, Number(count.getAttribute('data-total')));
          })
          .catch(function (error) {
            console.error('Unable to count the filtered products.', error);
            if (myToken === countToken) go.classList.remove('is-counting');
          });
      }, 150);
    };
    var openSheet = function (section) {
      var panel = results.querySelector('[data-dept-sheet]');
      if (!panel) return;
      // Fenêtre posée sur la page (au-dessus de l'en-tête et de la barre du bas).
      sheetHome = panel.parentNode;
      movedPanel = panel;
      panel.classList.add('is-mshein-moved');
      document.body.appendChild(panel);
      panel.hidden = false;
      sortGrids(panel);
      mergeShades(panel);
      syncFamilies(panel);
      renderPicked(panel);
      panel.querySelectorAll('[data-dept-section]').forEach(function (part) { syncPrice(part, false); });
      // Nombre actuel écrit à la mode du pays (4.112).
      var go = panel.querySelector('[data-dept-go]');
      var current = results.querySelector('[data-dept-count]');
      if (go && current) setGo(go, Number(current.getAttribute('data-total')), true);
      window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      if (section) openSection(panel, section);
    };
    // Choix de la fenêtre appliqués aux produits tout de suite (fenêtre gardée ouverte).
    var applyNow = function (panel) {
      params = new URLSearchParams(formQuery(panel.querySelector('[data-dept-form]')));
      reload();
    };
    // Après un rechargement fenêtre ouverte : la nouvelle fenêtre (nombres de Shopify à jour) prend la place de
    // l'ancienne, mêmes sections ouvertes, même tonalités ouvertes, même position.
    var adoptSheet = function () {
      var old = movedPanel;
      var fresh = results.querySelector('[data-dept-sheet]');
      if (!old || !fresh) return;
      var ids = function (selector) {
        return Array.prototype.map.call(old.querySelectorAll(selector), function (node) { return node.getAttribute('data-dept-section'); });
      };
      var openIds = ids('.mshein-fsec.is-open');
      var allIds = ids('.mshein-fsec.is-all');
      var shadesButton = old.querySelector('[data-dept-shades-open][aria-expanded="true"]');
      var openShades = shadesButton ? shadesButton.getAttribute('data-dept-shades-open') : '';
      var scroll = old.querySelector('[data-dept-sheet-body]').scrollTop;
      sheetHome = fresh.parentNode;
      fresh.classList.add('is-mshein-moved', 'is-open');
      fresh.hidden = false;
      old.replaceWith(fresh);
      movedPanel = fresh;
      fresh.querySelectorAll('.mshein-fsec').forEach(function (section) {
        var id = section.getAttribute('data-dept-section');
        setSection(section, openIds.indexOf(id) >= 0);
        if (allIds.indexOf(id) >= 0) {
          section.classList.add('is-all');
          var more = section.querySelector('[data-dept-more]');
          if (more) {
            more.setAttribute('aria-expanded', 'true');
            more.querySelector('span').textContent = more.getAttribute('data-less');
          }
        }
      });
      sortGrids(fresh);
      mergeShades(fresh);
      syncFamilies(fresh);
      renderPicked(fresh);
      fresh.querySelectorAll('[data-dept-section]').forEach(function (part) { syncPrice(part, false); });
      var reopen = openShades && fresh.querySelector('[data-dept-shades-open="' + openShades + '"]');
      if (reopen && !reopen.hidden) toggleShades(reopen);
      var go = fresh.querySelector('[data-dept-go]');
      var current = results.querySelector('[data-dept-count]');
      if (go && current) setGo(go, Number(current.getAttribute('data-total')), true);
      fresh.querySelector('[data-dept-sheet-body]').scrollTop = scroll;
    };
    var closeSheet = function () {
      var panel = sheet();
      if (!panel) return;
      // Fenêtre fermée (✕, à côté) après un changement : il est appliqué, rien n'est perdu.
      var form = panel.querySelector('[data-dept-form]');
      var changed = form && formQuery(form) !== params.toString();
      if (changed) params = new URLSearchParams(formQuery(form));
      panel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      movedPanel = null;
      window.setTimeout(function () {
        panel.hidden = true;
        panel.classList.remove('is-mshein-moved');
        if (sheetHome && sheetHome.isConnected) sheetHome.insertBefore(panel, sheetHome.querySelector('[data-mshein-grid], .mshein-feed__grid'));
        else panel.remove();
      }, 250);
      if (changed) reload();
    };

    // Tout sauf les filtres : le tri, et pour la recherche ses mots (q) et son type (type=product).
    var withoutFilters = function () {
      var kept = new URLSearchParams();
      params.forEach(function (value, name) {
        if (name.indexOf('filter.') !== 0) kept.append(name, value);
      });
      return kept;
    };

    var onClick = function (event) {
      var chip = event.target.closest('[data-dept-chip]');
      if (chip) {
        slot.querySelectorAll('[data-dept-chip]').forEach(function (button) { button.classList.toggle('is-on', button === chip); });
        chip.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        basePath = new URL(chip.getAttribute('data-dept-chip'), window.location.href).pathname;
        // Autre collection : ses propres filtres (le tri est gardé).
        params = withoutFilters();
        reload();
        return;
      }
      var view = event.target.closest('[data-dept-view]');
      if (view) {
        oneColumn = view.getAttribute('data-dept-view') === '1';
        results.querySelectorAll('[data-dept-view]').forEach(function (button) { button.classList.toggle('is-on', button === view); });
        masonry.setOneColumn(oneColumn);
        return;
      }
      var quick = event.target.closest('[data-dept-quick]');
      if (quick) {
        var name = quick.getAttribute('data-dept-quick');
        var value = quick.getAttribute('data-dept-quick-value');
        var values = params.getAll(name);
        params.delete(name);
        if (values.indexOf(value) < 0) params.append(name, value);
        else values.filter(function (item) { return item !== value; }).forEach(function (item) { params.append(name, item); });
        reload();
        return;
      }
      var open = event.target.closest('[data-dept-open]');
      if (open) openSheet(open.getAttribute('data-dept-open'));
    };
    var onChange = function (event) {
      if (!event.target.matches('[data-dept-sort]')) return;
      params.set('sort_by', event.target.value);
      reload();
    };
    // La fenêtre Filtri est déplacée sur la page : ses actions sont écoutées sur le document.
    var onSheet = function (event) {
      var panel = sheet();
      if (!panel || !panel.contains(event.target)) return;
      if (event.target === panel || event.target.closest('[data-dept-close]')) { closeSheet(); return; }
      var toggle = event.target.closest('[data-dept-toggle]');
      if (toggle) {
        var section = toggle.closest('[data-dept-section]');
        setSection(section, !section.classList.contains('is-open'));
        return;
      }
      var shadesButton = event.target.closest('[data-dept-shades-open]');
      if (shadesButton) {
        event.preventDefault();
        toggleShades(shadesButton);
        return;
      }
      var more = event.target.closest('[data-dept-more]');
      if (more) {
        var all = more.closest('[data-dept-section]').classList.toggle('is-all');
        more.setAttribute('aria-expanded', all ? 'true' : 'false');
        more.querySelector('span').textContent = more.getAttribute(all ? 'data-less' : 'data-more');
        return;
      }
      // Prix rapide (« Fino a 10 », « 10 – 25 »…) : choisi, ou retiré s'il l'était déjà.
      var quickPrice = event.target.closest('[data-dept-pq-min]');
      if (quickPrice) {
        var priceSection = quickPrice.closest('[data-dept-section]');
        var minInput = priceSection.querySelector('[data-dept-price="min"]');
        var maxInput = priceSection.querySelector('[data-dept-price="max"]');
        var same = quickPrice.getAttribute('aria-pressed') === 'true';
        minInput.value = same ? '' : quickPrice.getAttribute('data-dept-pq-min');
        maxInput.value = same ? '' : quickPrice.getAttribute('data-dept-pq-max');
        syncPrice(priceSection, false);
        renderPicked(panel);
        refreshCount(panel);
        return;
      }
      if (event.target.closest('[data-dept-reset]')) {
        panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) { input.checked = false; });
        panel.querySelectorAll('input[type="number"]').forEach(function (input) { input.value = ''; });
        panel.querySelectorAll('[data-dept-search]').forEach(function (input) {
          input.value = '';
          searchList(input);
        });
        panel.querySelectorAll('[data-dept-section]').forEach(function (part) { syncPrice(part, false); });
        syncFamilies(panel);
        renderPicked(panel);
        refreshCount(panel);
        // « Azzera » / « Cancella » : produits sans filtre tout de suite.
        applyNow(panel);
        return;
      }
      var unpick = event.target.closest('[data-dept-unpick]');
      if (unpick) {
        var pick = unpick.closest('[data-dept-picked]').msheinPicks[Number(unpick.getAttribute('data-dept-unpick'))];
        if (pick && pick.input && pick.input.hasAttribute('data-dept-family')) setFamily(pick.input, false);
        else if (pick && pick.input) pick.input.checked = false;
        if (pick && pick.price) {
          pick.price.forEach(function (input) { input.value = ''; });
          syncPrice(pick.price[0].closest('[data-dept-section]'), false);
        }
        renderPicked(panel);
        refreshCount(panel);
        // ✕ sur un choix : retiré des produits tout de suite.
        applyNow(panel);
      }
    };
    // Choix cochés, prix tapés ou glissés : pastilles, résumés et « Mostra N prodotti » suivent.
    var onSheetInput = function (event) {
      var panel = sheet();
      if (!panel || !panel.contains(event.target) || !event.target.matches('input')) return;
      if (event.target.matches('[data-dept-search]')) {
        searchList(event.target);
        return;
      }
      if (event.target.matches('[data-dept-family]')) setFamily(event.target, event.target.checked);
      if (event.target.matches('[data-family-member]')) {
        (event.target.msheinTwins || []).forEach(function (twin) { twin.checked = event.target.checked; });
        syncFamily(event.target.closest('[data-dept-section]'), event.target.getAttribute('data-family-member'));
      }
      if (event.target.matches('[data-dept-range-input]')) slidePrice(event.target);
      if (event.target.matches('[data-dept-price]')) syncPrice(event.target.closest('[data-dept-section]'), false);
      renderPicked(panel);
      refreshCount(panel);
    };
    var onSubmit = function (event) {
      var panel = sheet();
      if (!event.target.matches('[data-dept-form]') || !panel || !panel.contains(event.target)) return;
      event.preventDefault();
      params = withoutFilters();
      new FormData(event.target).forEach(function (value, name) {
        if (String(value).trim() !== '') params.append(name, value);
      });
      closeSheet();
      reload();
    };
    slot.addEventListener('click', onClick);
    slot.addEventListener('change', onChange);
    document.addEventListener('click', onSheet);
    document.addEventListener('input', onSheetInput);
    document.addEventListener('submit', onSubmit);
    bind();
    return {
      hasMore: function () { return masonry && masonry.hasMore(); },
      loadMore: function () { if (masonry) masonry.loadMore(); },
      destroy: function () {
        token += 1;
        if (masonry) masonry.destroy();
        slot.removeEventListener('click', onClick);
        slot.removeEventListener('change', onChange);
        document.removeEventListener('click', onSheet);
        document.removeEventListener('input', onSheetInput);
        document.removeEventListener('submit', onSubmit);
        if (movedPanel) {
          movedPanel.remove();
          movedPanel = null;
          document.documentElement.style.overflow = '';
        }
      }
    };
  };

  window.msheinResults = { create: createProducts };

  // Recherche (sections/mobile-home-shein.liquid, partie « search ») : mêmes Filtri / tri / colonnes que les rayons,
  // pages suivantes au défilement ; la recherche garde ses mots (?q=…) à chaque tri ou filtre. Aussi sur ordinateur.
  var searchBlock = window.msheinMasonry && document.querySelector('[data-mshein-search]');
  if (searchBlock) {
    createProducts(searchBlock, searchBlock.getAttribute('data-path') || '/search', window.location.search.slice(1), 'mshein-search');
    window.msheinMasonry.watchReveal(searchBlock);
  }

  if (window.msheinTabs) return;
  var mobile = window.matchMedia('(max-width: 760px)');
  if (!mobile.matches || !document.body.classList.contains('mshein-home') || !window.msheinMasonry) return;
  var nav = document.querySelector('.mobile-temu-header .mobile-temu-categories');
  if (!nav) return;
  var navList = nav.querySelector('ul') || nav;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Page de base : l'accueil (ses sections), ou la page collection (les blocs de son rayon).
  var coll = document.querySelector('[data-mshein-coll]');
  // Page « In offerta » (/collections/all?view=offerte) : ses produits sont redemandés avec son modèle (promotions seulement).
  var collView = coll ? coll.getAttribute('data-view') || '' : '';
  var sectionOf = function (element) { return element ? element.closest('.shopify-section') : null; };
  var collPart = function (name) { return coll.querySelector('[data-dept-part="' + name + '"]'); };
  var home = coll ? {
    hero: collPart('hero'),
    tiles: collPart('cats'),
    mods: collPart('mods'),
    feed: collPart('products')
  } : {
    hero: sectionOf(document.querySelector('[data-mshein-hero]')),
    tiles: sectionOf(document.querySelector('.category-tiles--scroll')),
    mods: sectionOf(document.querySelector('.mshein-mods[data-mshein-home]')),
    feed: sectionOf(document.querySelector('[data-mshein-feed]'))
  };
  if (!home.hero || !home.feed) return;

  var slug = function (text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };

  // Onglets : liens du header vers une collection de la boutique (sans paramètres).
  var tabs = Array.prototype.slice.call(nav.querySelectorAll('a[href]')).map(function (link) {
    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.search || !/\/collections\/[^/]+\/?$/.test(url.pathname)) return null;
    return { link: link, path: url.pathname, query: '', key: url.pathname, slug: slug(link.textContent.trim()) };
  }).filter(Boolean);
  if (!tabs.length) return;
  // Autres collections ouvertes sur place (vignettes, icônes, tuiles, « Vedi tutto », cartes, panneaux Categoria / Esplora…) :
  // ajoutées ici au premier toucher, numérotées après les onglets (tabs.length + n). mark : onglet du header à marquer.
  var extras = [];
  var pageAt = function (index) { return index < tabs.length ? tabs[index] : extras[index - tabs.length]; };
  var trimPath = function (path) { return String(path).replace(/\/+$/, ''); };
  // baseIndex : onglet qui EST la page de base (page collection d'un rayon), sinon -1 (accueil, sous-catégorie).
  // baseMark : onglet marqué sur la page de base (rayon de la collection, is-active de sections/header.liquid).
  var baseIndex = -1;
  var baseMark = -1;
  tabs.forEach(function (tab, index) {
    tab.link.setAttribute('role', 'tab');
    tab.link.setAttribute('aria-selected', 'false');
    tab.link.setAttribute('data-mshein-tab', String(index));
    // « In offerta » est sur /collections/all mais n'est pas l'onglet « Tutti i Prodotti » : aucun onglet marqué.
    if (coll && !collView && trimPath(tab.path) === trimPath(window.location.pathname)) baseIndex = index;
    if (coll && !collView && baseMark < 0 && tab.link.classList.contains('is-active')) baseMark = index;
    tab.link.classList.remove('is-active');
  });
  if (baseIndex >= 0) baseMark = baseIndex;
  // Adresse de la page chargée (l'adresse affichée change ensuite avec l'onglet ouvert).
  var basePathname = window.location.pathname;
  var baseUrl = basePathname + window.location.search;
  var minIndex = baseIndex >= 0 ? 0 : -1;
  var isBase = function (index) { return index === baseIndex; };
  // Bannières des rayons préparées dans la page (snippets/mshein-tab-heroes.liquid), par adresse de collection.
  var heroTemplates = {};
  document.querySelectorAll('template[data-mshein-hero-for]').forEach(function (template) {
    heroTemplates[trimPath(new URL(template.getAttribute('data-mshein-hero-for'), window.location.href).pathname)] = template;
  });

  // Emplacements des pages de rayon, à côté des sections de l'accueil qu'elles remplacent.
  var makeSlot = function (after, name) {
    var slot = document.createElement('div');
    slot.className = 'mshein-dept-slot';
    slot.hidden = true;
    slot.setAttribute('data-dept-slot', name);
    after.after(slot);
    return slot;
  };
  var slots = {
    hero: makeSlot(home.hero, 'hero'),
    cats: makeSlot(home.tiles || home.hero, 'cats'),
    mods: makeSlot(home.mods || home.feed, 'mods'),
    products: makeSlot(home.feed, 'products')
  };

  // Adresse (#donna…) et position gardée : fonctions d'origine du navigateur. Une app installée les remplace par une
  // version qui prévient d'autres scripts à chaque appel (~33 ms au lieu de ~1 ms, 2 à 3 fois par toucher d'onglet).
  var historyCall = function (method) {
    var original = History.prototype[method];
    var usable = typeof original === 'function' && /\[native code\]/.test(Function.prototype.toString.call(original));
    return function () { return (usable ? original : history[method]).apply(history, arguments); };
  };
  var pushState = historyCall('pushState');
  var replaceState = historyCall('replaceState');
  var page = document.getElementById('content') || home.feed.parentNode;
  var current = baseIndex;
  var startDone = false;
  var requestToken = 0;
  var cache = {};
  var ready = {};
  var products = null;

  var syncHeader = function () { if (window.msheinSyncHeader) window.msheinSyncHeader(); };
  // Rayon (onglet ou autre collection, avec son tri / ses filtres éventuels) : demandé une fois, gardé en mémoire.
  var fetchDept = function (tab) {
    if (!cache[tab.key]) {
      cache[tab.key] = fetch(tab.path + '?view=' + (tab.view || 'mshein-dept') + (tab.query ? '&' + tab.query : ''), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Department request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          ready[tab.key] = true;
          return html;
        })
        .catch(function (error) {
          delete cache[tab.key];
          throw error;
        });
    }
    return cache[tab.key];
  };
  // Rayons voisins préparés quand le téléphone est libre : glisser vers eux les affiche aussitôt.
  var whenIdle = function (run, timeout) {
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: timeout });
    else window.setTimeout(run, 600);
  };
  // Puis tous les autres rayons, un par un, quand le téléphone est libre : chaque onglet s'ouvre ensuite tout de suite.
  // Pas en mode économie de données ni en connexion lente (seulement les voisins et le rayon touché).
  var connection = navigator.connection || {};
  var prefetchAllowed = !connection.saveData && !/(^|-)2g$/.test(connection.effectiveType || '');
  var prefetchAllStarted = false;
  // Photos des bannières préparées : chargées à l'avance (même taille que l'affichage), visibles dès le toucher.
  var warmHeroImages = function () {
    Object.keys(heroTemplates).forEach(function (path) {
      heroTemplates[path].content.querySelectorAll('img').forEach(function (source) {
        var image = new Image();
        if (source.getAttribute('sizes')) image.sizes = source.getAttribute('sizes');
        if (source.getAttribute('srcset')) image.srcset = source.getAttribute('srcset');
        image.src = source.getAttribute('src');
      });
    });
  };
  var prefetchAll = function () {
    if (prefetchAllStarted || !prefetchAllowed) return;
    prefetchAllStarted = true;
    var next = 0;
    var step = function () {
      while (next < tabs.length && cache[tabs[next].key]) next += 1;
      if (next >= tabs.length) return;
      var tab = tabs[next];
      next += 1;
      fetchDept(tab).catch(function () {}).then(function () { whenIdle(step, 4000); });
    };
    whenIdle(step, 4000);
  };
  var prefetchAround = function (index) {
    whenIdle(function () {
      var nearby = [index + 1, index - 1].filter(function (near) { return near >= 0 && near < tabs.length; })
        .map(function (near) { return fetchDept(tabs[near]).catch(function () {}); });
      Promise.all(nearby).then(prefetchAll);
    }, 2500);
  };
  // Blocs visibles de la page, du haut jusqu'aux produits (avantages et coupon compris) : ordre de la cascade.
  var pageBlocks = function (last) {
    var blocks = [];
    // Sans mesurer la page (une mesure ici = toute la page recalculée) : les blocs cachés en mobile ne s'animent pas.
    for (var node = slots.hero.parentNode.firstElementChild; node; node = node.nextElementSibling) {
      if (!node.hidden) blocks.push(node);
      if (node === last) break;
    }
    return blocks;
  };
  // En-tête et bannière (1er bloc) affichés tout de suite, puis les autres blocs l'un après l'autre, rapidement,
  // venant du côté de l'onglet choisi (dir 1 : droite). Animations du navigateur (element.animate) : aucune mesure de
  // la page (avant : une par bloc, ~0,2 s à chaque onglet).
  var running = [];
  var enter = function (elements, dir) {
    running.forEach(function (animation) { animation.cancel(); });
    running = [];
    if (reduceMotion || !Element.prototype.animate) return;
    var shown = 0;
    elements.forEach(function (element) {
      if (!element || element.hidden) return;
      if (shown) {
        running.push(element.animate([
          { opacity: 0, transform: 'translate3d(' + (dir || 0) * 32 + 'px, 10px, 0)' },
          { opacity: 1, transform: 'none' }
        ], { duration: 300, delay: 40 + (shown - 1) * 50, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }));
      }
      shown += 1;
    });
  };
  // Onglet ouvert au milieu de la barre.
  var centerTab = function (index, smooth) {
    if (index < 0) {
      navList.scrollTo({ left: 0, behavior: smooth ? 'smooth' : 'auto' });
      return;
    }
    var link = tabs[index].link;
    var item = link.closest('li') || link;
    navList.scrollTo({ left: item.offsetLeft - (navList.clientWidth - item.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
  };
  var markTabs = function (index, smooth) {
    if (isBase(index)) index = baseMark;
    // Autre collection : l'onglet du rayon qui la contient (connu à l'arrivée de la page), sinon l'onglet déjà marqué.
    else if (index >= tabs.length) index = pageAt(index).mark;
    if (typeof index !== 'number' || index >= tabs.length) return;
    tabs.forEach(function (tab, tabIndex) {
      var on = tabIndex === index;
      tab.link.classList.toggle('is-tab-on', on);
      tab.link.classList.remove('is-pending');
      tab.link.setAttribute('aria-selected', String(on));
    });
    centerTab(index, smooth);
  };
  var setHomeVisible = function (visible, keepTiles) {
    home.hero.hidden = !visible;
    // Page collection : sa bannière règle l'en-tête (transparent dessus) seulement quand elle est affichée.
    if (coll) home.hero.toggleAttribute('data-mshein-hero-active', visible);
    // Tuiles de l'accueil gardées pour « Tutti i Prodotti » (pas les sous-catégories d'une page collection).
    if (home.tiles) home.tiles.hidden = !visible && !(keepTiles && !coll);
    if (home.mods) home.mods.hidden = !visible;
    home.feed.hidden = !visible;
  };
  // keepHero : bannière déjà affichée pour ce rayon (préparée), gardée telle quelle (pas de saut d'image).
  var clearSlots = function (keepHero) {
    if (products) products.destroy();
    products = null;
    Object.keys(slots).forEach(function (name) {
      if (keepHero && name === 'hero') return;
      slots[name].replaceChildren();
      slots[name].hidden = true;
      slots[name].removeAttribute('data-mshein-hero-active');
      slots[name].removeAttribute('data-hero-for');
    });
  };
  // Retour sur un onglet déjà vu : même position (pages de produits ajoutées si besoin).
  var restoreScroll = function (y, more) {
    window.scrollTo({ top: y || 0 });
    syncHeader();
    if (!y || !more) return;
    var tries = 0;
    var step = function () {
      if (document.documentElement.scrollHeight >= y + window.innerHeight || tries++ > 6 || !more.hasMore()) {
        window.scrollTo({ top: y });
        syncHeader();
        return;
      }
      more.loadMore();
      window.setTimeout(step, 350);
    };
    step();
  };


  // Page collection : son propre bloc de recherche et ses produits (gardés pendant qu'un autre onglet est ouvert).
  var baseProducts = coll ? createProducts(home.feed, window.location.pathname, window.location.search, collView || undefined) : null;
  if (coll) window.msheinMasonry.watchReveal(coll);

  /* ---------- Changement d'onglet (sans rechargement) ---------- */
  var renderDept = function (tab, html) {
    var dept = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mshein-dept]');
    if (!dept) throw new Error('Department markup missing');
    var part = function (name) {
      var element = dept.querySelector('[data-dept-part="' + name + '"]');
      return element ? element.innerHTML : '';
    };
    var keepHero = slots.hero.getAttribute('data-hero-for') === tab.key && Boolean(slots.hero.firstElementChild);
    clearSlots(keepHero);
    var isAll = dept.hasAttribute('data-all');
    // « Tutti i Prodotti » : les tuiles de l'accueil restent (ses icônes), comme le prototype.
    setHomeVisible(false, isAll);
    // Partie vide (ex. pas de sous-catégories) : emplacement caché (vérifié sur le texte reçu, sans relire la page).
    Object.keys(slots).forEach(function (name) {
      if (keepHero && name === 'hero') return;
      var html = part(name);
      slots[name].innerHTML = html;
      slots[name].hidden = !html.trim();
    });
    slots.hero.setAttribute('data-mshein-hero-active', '');
    window.msheinMasonry.watchReveal(slots.cats);
    window.msheinMasonry.watchReveal(slots.mods);
    products = createProducts(slots.products, tab.path, tab.query, tab.view);
    // Autre collection : l'onglet du header du rayon qui la contient (ex. Bikini → Donna), donné par la page reçue.
    var top = dept.getAttribute('data-top');
    if (tab.extra && top) {
      var topPath = trimPath(new URL(top, window.location.href).pathname);
      tabs.forEach(function (item, itemIndex) { if (trimPath(item.path) === topPath) tab.mark = itemIndex; });
      if (pageAt(current) === tab) markTabs(current, true);
    }
  };
  // Bannière immédiate d'une autre collection : photo et nom du lien touché (la vraie bannière la remplace à l'arrivée).
  var provisionalHero = function (tab) {
    var section = document.createElement('section');
    section.className = 'mshein-dhero';
    var media = document.createElement('span');
    media.className = 'mshein-dhero__media';
    if (tab.image) {
      var image = tab.image.cloneNode(false);
      image.removeAttribute('loading');
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.setAttribute('sizes', '100vw');
      image.alt = '';
      media.appendChild(image);
    }
    var shade = document.createElement('span');
    shade.className = 'mshein-dhero__shade';
    var text = document.createElement('span');
    text.className = 'mshein-dhero__txt';
    var title = document.createElement('b');
    title.className = 'mshein-dhero__title';
    title.textContent = tab.title || '';
    text.appendChild(title);
    media.append(shade, text);
    section.appendChild(media);
    return section;
  };
  // Rayon pas encore reçu : sa vraie bannière tout de suite (préparée dans la page, snippets/mshein-tab-heroes.liquid),
  // forme grise seulement pour les blocs dessous.
  var showLoading = function (tab) {
    clearSlots();
    setHomeVisible(false, false);
    var shape = function (kind, count) {
      return '<div class="mshein-dskel mshein-dskel--' + kind + '" aria-hidden="true">' + new Array(count + 1).join('<i></i>') + '</div>';
    };
    var heroTemplate = !tab.query && !tab.view && heroTemplates[trimPath(tab.path)];
    if (heroTemplate) {
      slots.hero.replaceChildren(heroTemplate.content.cloneNode(true));
      slots.hero.setAttribute('data-hero-for', tab.key);
    } else if (tab.extra) {
      slots.hero.replaceChildren(provisionalHero(tab));
    } else {
      slots.hero.innerHTML = shape('hero', 1);
    }
    slots.cats.innerHTML = shape('cats', 5);
    slots.products.innerHTML = shape('grid', 4);
    slots.hero.hidden = false;
    slots.cats.hidden = false;
    slots.products.hidden = false;
    slots.hero.setAttribute('data-mshein-hero-active', '');
  };

  // index : baseIndex = page de base (accueil -1, ou la page collection), sinon l'onglet.
  // fromHistory : lien direct, ou Retour / Avanti du navigateur.
  var showTab = function (index, fromHistory, y) {
    if (!fromHistory) replaceState(Object.assign({}, history.state, { mshTab: current, mshY: window.scrollY }), '', window.location.href);
    // Sens de l'arrivée : l'onglet de droite arrive par la droite (rien au premier affichage).
    var dir = startDone ? (index > current ? 1 : -1) : 0;
    current = index;
    var token = ++requestToken;
    markTabs(index, !fromHistory);
    if (!fromHistory) {
      // Vraie adresse du rayon (/collections/…, avec son tri / ses filtres) : lien partagé ou page rechargée = la vraie
      // page collection, au même design.
      var target = pageAt(index);
      pushState({ mshTab: index, mshY: 0 }, '', isBase(index) ? baseUrl : target.address || target.path + (target.query ? '?' + target.query : ''));
    }
    if (isBase(index)) {
      clearSlots();
      setHomeVisible(true);
      restoreScroll(y, baseProducts);
      if (dir) enter(pageBlocks(home.feed), dir);
      prefetchAround(index);
      return;
    }
    var tab = pageAt(index);
    // Page pas encore reçue : sa forme s'affiche aussitôt, le contenu la remplace à l'arrivée.
    var waiting = !ready[tab.key];
    if (waiting) {
      showLoading(tab);
      window.scrollTo({ top: 0 });
      syncHeader();
      enter(pageBlocks(slots.products), dir);
    }
    fetchDept(tab).then(function (html) {
      if (token !== requestToken) return;
      renderDept(tab, html);
      restoreScroll(y, products);
      // Après la forme grise, seul le nouveau contenu des emplacements s'anime (le reste est déjà là).
      enter(waiting ? [slots.hero, slots.cats, slots.mods, slots.products] : pageBlocks(slots.products), waiting ? 0 : dir);
      prefetchAround(index);
    }).catch(function (error) {
      console.error('Unable to open the department tab.', error);
      if (token !== requestToken) return;
      // En cas d'erreur réseau : la vraie page de la collection.
      window.location.href = tab.href || tab.link.href;
    });
  };

  // Onglet touché : son rayon, ou retour en haut si c'est déjà l'onglet ouvert.
  var openTab = function (index) {
    if (index === current) window.scrollTo({ top: 0, behavior: 'smooth' });
    else showTab(index);
  };
  // Clic sur un onglet, le logo ou « Home » : changement sans rechargement (souris, clavier ; au doigt : touchend plus bas).
  var handleClick = function (event) {
    if (!mobile.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[data-mshein-tab]');
    if (link && nav.contains(link)) {
      event.preventDefault();
      openTab(Number(link.getAttribute('data-mshein-tab')));
      return;
    }
    // Accueil : logo ou « Home » de la barre du bas.
    var homeLink = event.target.closest && event.target.closest('.mobile-home-header__logo, .mobile-bottom-navigation a, .mobile-bottom-nav a');
    if (homeLink) {
      var target = new URL(homeLink.href, window.location.href);
      var trim = function (path) { return String(path).replace(/\/+$/, ''); };
      // Adresse de l'accueil (avec la langue : « / », « /de »…).
      if (target.origin === window.location.origin && trim(target.pathname) === trim(basePathname) && !target.hash) {
        event.preventDefault();
        if (!isBase(current)) showTab(baseIndex);
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };
  window.addEventListener('click', handleClick, true);
  // Préchargement au premier contact du doigt : la page du rayon est souvent prête au relâchement.
  nav.addEventListener('pointerdown', function (event) {
    var link = event.target.closest('a[data-mshein-tab]');
    if (link) fetchDept(tabs[Number(link.getAttribute('data-mshein-tab'))]).catch(function () {});
  }, { passive: true });

  // Téléphone : l'onglet s'ouvre dès que le doigt se lève (comme une app), sans attendre le « clic » qui suit ; ce clic
  // est annulé, donc les scripts de statistiques ne l'analysent plus (0,2 à 1,2 s de blocage à chaque toucher).
  // Le doigt qui fait défiler la barre d'onglets (il bouge) ne change pas d'onglet.
  var tap = null;
  nav.addEventListener('touchstart', function (event) {
    var link = event.touches.length === 1 && event.target.closest('a[data-mshein-tab]');
    tap = link ? { link: link, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  nav.addEventListener('touchmove', function (event) {
    if (tap && (Math.abs(event.touches[0].clientX - tap.x) > 10 || Math.abs(event.touches[0].clientY - tap.y) > 10)) tap = null;
  }, { passive: true });
  nav.addEventListener('touchend', function (event) {
    var touched = tap;
    tap = null;
    if (!touched || !mobile.matches || !event.cancelable) return;
    event.preventDefault();
    // Toucher traité : il ne remonte pas jusqu'aux scripts de statistiques (qui l'analysent aussi, ~0,1 s).
    event.stopImmediatePropagation();
    openTab(Number(touched.link.getAttribute('data-mshein-tab')));
  }, { passive: false });
  nav.addEventListener('touchcancel', function () { tap = null; }, { passive: true });

  /* ---------- Toute autre collection : vignettes, icônes, tuiles, « Vedi tutto », cartes, panneaux Categoria / Esplora… ---------- */
  // Même principe que les onglets : sur place, sans rechargement, vraie adresse (avec son tri / ses filtres).
  var collectionLink = function (target) {
    var link = target && target.closest && target.closest('a[href]');
    if (!link || nav.contains(link) || link.target === '_blank' || link.hasAttribute('download') || link.closest('[data-dept-sheet]')) return null;
    // Ancre de la page (rayons à gauche du panneau Categoria) : pas un lien de collection, même complétée par le navigateur.
    if ((link.getAttribute('href') || '').charAt(0) === '#') return null;
    var url = new URL(link.href, window.location.href);
    var match = url.pathname.match(/\/collections\/([^/]+)\/?$/);
    // vendors / types : listes spéciales de Shopify (pas des collections). ?view=… : morceau de page chargé par
    // un script (produits suivants du panneau Categoria…), pas une page.
    if (url.origin !== window.location.origin || !match || /^(vendors|types)$/.test(match[1])) return null;
    // « In offerta » (/collections/all?view=offerte : « Super saldi », « Vedi tutte ») : rayon des promotions.
    if (url.searchParams.get('view') === 'offerte') return { link: link, url: url, sale: true };
    if (url.searchParams.has('view')) return null;
    return { link: link, url: url };
  };
  var markOf = function (index) {
    if (isBase(index)) return baseMark;
    return index >= tabs.length ? pageAt(index).mark : index;
  };
  // Nom du lien pour la bannière immédiate : premier texte non vide (titre de carte, nom de vignette…).
  var linkTitle = function (link) {
    var parts = link.querySelectorAll('.mshein-mod__hd b, .mshein-dhero__title, b, strong, span');
    for (var i = 0; i < parts.length; i += 1) {
      var text = parts[i].textContent.trim();
      if (text && !parts[i].querySelector('img')) return text.replace(/\s+/g, ' ');
    }
    return (link.getAttribute('aria-label') || link.textContent || '').trim().replace(/\s+/g, ' ');
  };
  var pageIndexFor = function (found) {
    if (found.sale) {
      // Déjà sur la page « In offerta » : ses produits.
      if (collView === 'mshein-dept-sale') return baseIndex;
      for (var s = 0; s < extras.length; s += 1) if (extras[s].view === 'mshein-dept-sale') return tabs.length + s;
      extras.push({
        path: found.url.pathname,
        // Promotions les plus vendues d'abord (le tri par défaut de « Tutti i prodotti » est alphabétique).
        query: 'sort_by=' + (found.url.searchParams.get('sort_by') || 'best-selling'),
        key: 'sale:' + found.url.pathname,
        view: 'mshein-dept-sale',
        address: found.url.pathname + '?view=offerte&sort_by=' + (found.url.searchParams.get('sort_by') || 'best-selling'),
        href: found.url.href,
        extra: true,
        title: linkTitle(found.link).slice(0, 60),
        image: found.link.querySelector('img'),
        // Aucun onglet du header marqué (ce n'est pas « Tutti i Prodotti »).
        mark: -1
      });
      return tabs.length + extras.length - 1;
    }
    var params = new URLSearchParams(found.url.search);
    params.delete('page');
    params.delete('view');
    var query = params.toString();
    var path = found.url.pathname;
    if (!query) {
      for (var i = 0; i < tabs.length; i += 1) if (trimPath(tabs[i].path) === trimPath(path)) return i;
      if (coll && trimPath(path) === trimPath(basePathname) && !window.location.search) return baseIndex;
    }
    var key = path + '?' + query;
    for (var j = 0; j < extras.length; j += 1) if (extras[j].key === key) return tabs.length + j;
    extras.push({
      path: path,
      query: query,
      key: key,
      href: found.url.href,
      extra: true,
      title: linkTitle(found.link).slice(0, 60),
      image: found.link.querySelector('img'),
      mark: markOf(current)
    });
    return tabs.length + extras.length - 1;
  };
  // Lien vers la collection déjà ouverte (ex. « Vedi tutto » de sa bannière) : ses produits.
  var scrollToProducts = function () {
    var holder = isBase(current) ? home.feed : slots.products;
    var block = holder && holder.querySelector('[data-dept-block]');
    if (!block) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var rootStyle = getComputedStyle(document.documentElement);
    var offset = parseFloat(rootStyle.getPropertyValue('--mshein-tabs-top')) || parseFloat(rootStyle.getPropertyValue('--mshein-header-h')) || 0;
    window.scrollTo({ top: block.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  };
  var openCollection = function (found) {
    if (window.msheinPanels) window.msheinPanels.closeAll();
    var index = pageIndexFor(found);
    if (index === current) scrollToProducts();
    else showTab(index);
  };
  window.addEventListener('click', function (event) {
    if (!mobile.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var found = collectionLink(event.target);
    if (!found) return;
    event.preventDefault();
    openCollection(found);
  }, true);
  // Au doigt : préparé dès le contact, ouvert quand le doigt se lève (le clic qui suit est annulé) ; un doigt qui fait
  // défiler (une bande, la page) n'ouvre rien.
  var linkTap = null;
  document.addEventListener('touchstart', function (event) {
    var found = event.touches.length === 1 && collectionLink(event.target);
    linkTap = found ? { found: found, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    if (found) fetchDept(pageAt(pageIndexFor(found))).catch(function () {});
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function (event) {
    if (linkTap && (Math.abs(event.touches[0].clientX - linkTap.x) > 10 || Math.abs(event.touches[0].clientY - linkTap.y) > 10)) linkTap = null;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (event) {
    var touched = linkTap;
    linkTap = null;
    if (!touched || !mobile.matches || !event.cancelable) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openCollection(touched.found);
  }, { passive: false, capture: true });
  document.addEventListener('touchcancel', function () { linkTap = null; }, { passive: true, capture: true });
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') return;
    var found = collectionLink(event.target);
    if (found) fetchDept(pageAt(pageIndexFor(found))).catch(function () {});
  }, { passive: true, capture: true });

  /* ---------- Glisser le doigt : rayon voisin (accueil ← Tutti i Prodotti → Donna → …) ---------- */
  // Pas de changement d'onglet depuis une bande qui défile déjà de côté (bannière, puces, vignettes…) ni un champ.
  var scrollsSideways = function (element) {
    for (var node = element; node && node !== page; node = node.parentElement) {
      if (node.matches('.swiper, input, select, textarea, [data-dept-sheet]')) return true;
      if (node.scrollWidth > node.clientWidth + 1 && /auto|scroll/.test(getComputedStyle(node).overflowX)) return true;
    }
    return false;
  };
  var drag = null;
  var setDrag = function (shift) {
    page.style.transform = shift ? 'translate3d(' + shift + 'px, 0, 0)' : '';
    page.style.opacity = shift ? String(1 - Math.min(Math.abs(shift) / window.innerWidth, 1) * 0.5) : '';
  };
  var release = function (shift, to, done) {
    if (reduceMotion || !page.animate) { setDrag(0); done(); return; }
    var from = { transform: 'translate3d(' + shift + 'px, 0, 0)', opacity: page.style.opacity || 1 };
    setDrag(0);
    var animation = page.animate([from, { transform: 'translate3d(' + to + 'px, 0, 0)', opacity: to ? 0.35 : 1 }], { duration: to ? 170 : 220, easing: 'cubic-bezier(0.3, 0.7, 0.4, 1)' });
    animation.onfinish = done;
  };
  page.addEventListener('touchstart', function (event) {
    drag = null;
    if (!mobile.matches || event.touches.length !== 1 || document.documentElement.style.overflow === 'hidden' || scrollsSideways(event.target)) return;
    var touch = event.touches[0];
    drag = { x: touch.clientX, y: touch.clientY, time: Date.now(), axis: '', shift: 0 };
  }, { passive: true });
  page.addEventListener('touchmove', function (event) {
    if (!drag || event.touches.length !== 1) return;
    var touch = event.touches[0];
    var dx = touch.clientX - drag.x;
    var dy = touch.clientY - drag.y;
    if (!drag.axis) {
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      drag.axis = Math.abs(dx) > Math.abs(dy) * 1.3 ? 'x' : 'y';
    }
    if (drag.axis !== 'x') return;
    event.preventDefault();
    drag.target = current + (dx < 0 ? 1 : -1);
    // Autre collection ouverte (pas un onglet) : pas de voisin à glisser, la page résiste.
    drag.edge = current >= tabs.length || drag.target < minIndex || drag.target >= tabs.length;
    if (!drag.edge && drag.target >= 0) fetchDept(tabs[drag.target]).catch(function () {});
    // Au bout de la liste : la page résiste.
    drag.shift = drag.edge ? dx * 0.2 : dx;
    setDrag(drag.shift);
  }, { passive: false });
  var endDrag = function () {
    var gesture = drag;
    drag = null;
    if (!gesture || gesture.axis !== 'x') return;
    var distance = Math.abs(gesture.shift);
    var fast = distance > 40 && distance / Math.max(Date.now() - gesture.time, 1) > 0.45;
    if (gesture.edge || !(distance > window.innerWidth * 0.22 || fast)) {
      release(gesture.shift, 0, function () {});
      return;
    }
    var out = gesture.shift < 0 ? -window.innerWidth * 0.45 : window.innerWidth * 0.45;
    release(gesture.shift, out, function () {
      showTab(gesture.target);
    });
  };
  page.addEventListener('touchend', endDrag, { passive: true });
  page.addEventListener('touchcancel', endDrag, { passive: true });

  // Retour / Avanti du navigateur : l'onglet de cette étape, sans rechargement (anciens liens #donna… : nom du rayon).
  var tabFromHash = function () {
    var hash = window.location.hash.replace(/^#/, '');
    for (var index = 0; index < tabs.length; index += 1) {
      if (tabs[index].slug === hash) return index;
    }
    return baseIndex;
  };
  window.addEventListener('popstate', function (event) {
    // Retour depuis une fiche ouverte sur place : assets/mobile-pdp-layer.js remet la page à sa position (et la fait
    // glisser) ; refaire ici le défilement et la mesure de la page retardait le glissement.
    if (window.__pdpSwap && window.__pdpSwap.handlesBack && window.__pdpSwap.handlesBack()) return;
    var state = event.state;
    var index = state && typeof state.mshTab === 'number' ? state.mshTab : tabFromHash();
    var y = state && state.mshY ? state.mshY : 0;
    if (index !== current) showTab(index, true, y);
    else restoreScroll(y, isBase(current) ? baseProducts : products);
  });
  // Départ vers une autre page : position gardée pour le retour.
  window.addEventListener('pagehide', function () {
    replaceState(Object.assign({}, history.state, { mshTab: current, mshY: window.scrollY }), '', window.location.href);
  });

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  // Retour sur la page depuis une fiche produit, ou ancien lien direct (#donna…) : l'onglet de l'adresse s'ouvre
  // directement ; un ancien lien #… prend la vraie adresse du rayon (/collections/…).
  var startState = history.state;
  var startIndex = startState && typeof startState.mshTab === 'number' ? startState.mshTab : tabFromHash();
  if (startIndex >= tabs.length || startIndex < minIndex) startIndex = baseIndex;
  if (!isBase(startIndex)) showTab(startIndex, true, startState && startState.mshY);
  else if (startState && startState.mshY) restoreScroll(startState.mshY, baseProducts);
  var startUrl = !startState && !isBase(current) && window.location.hash ? tabs[current].path : window.location.href;
  replaceState(Object.assign({}, history.state, { mshTab: current, mshY: startState && startState.mshY || 0 }), '', startUrl);
  markTabs(current, false);
  if (isBase(current)) prefetchAround(current);
  if (prefetchAllowed) whenIdle(warmHeroImages, 1500);
  startDone = true;

  window.msheinTabs = { show: showTab };
})();
